import { render, staticRenderFns } from "./BatchDetryComponent.vue?vue&type=template&id=95f633bc"
import script from "./BatchDetryComponent.vue?vue&type=script&lang=js"
export * from "./BatchDetryComponent.vue?vue&type=script&lang=js"
import style0 from "./BatchDetryComponent.vue?vue&type=style&index=0&id=95f633bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports